import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

export function useGetUser() {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      try {
        const decodedUser: User = jwtDecode(accessToken);
        setUser(decodedUser);
      } catch (error) {
        console.error('Invalid token or failed to decode', error);
        setUser(null);
      }
    }
  }, []);

  return user;
}
